"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Events = void 0;
class Events {
    static GenericEvent;
    static BaseEvent;
    static EventMessage;
    static NetworkEvent;
    static UserEvent;
    static StateEvent;
    static SignoutEvent;
}
exports.Events = Events;
//# sourceMappingURL=index.js.map